// Accepts only same-site paths from the ?redirect= query param.
// Without this check, /auth?redirect=https://evil.com would send users to another site after login.
export const getSafeRedirect = (target: string | null, fallback: string): string => {
    const isSafePath =
        !!target &&
        target.startsWith("/") &&
        !target.startsWith("//") &&
        !target.startsWith("/\\");

    return isSafePath ? target : fallback;
};